import { ReactNode, ComponentProps } from 'react';
import { withStyles, Card } from 'vopay';
import { Title, DetailsRows } from 'UI';
import styles from './DetailRowsCard.module.scss';

const cn = withStyles(styles);

type DetailsRowsProps = ComponentProps<typeof DetailsRows>;

type DetailRowsCardProps = Omit<DetailsRowsProps, 'className'> & {
  title: ReactNode;
  className?: string;
};

export default function DetailRowsCard({ title, details, className }: DetailRowsCardProps) {
  return (
    <Card className={cn('detailRowsCard', className)}>
      <Title level="4" className={cn('title')}>
        {title}
      </Title>

      <DetailsRows className={cn('rows')} details={details} />
    </Card>
  );
}
